import moment from "moment"
import { v4 as uuidv4 } from 'uuid'

const reservaForm = {
    atrativo: {},
    atrativo_id: '',
    name: '',
    surname: 'Janoo',
    cpf_cnpj: '01234567890',
    phoneFlag: '55',
    phone: '',
    payment_method: '',
    email: '',
    date: moment().format('YYYY-MM-DD'),
    time: '',
    hash: uuidv4().toUpperCase(),
    confirm_term: false,
    payLater: false,
    auto_checkin: false,
    auto_checkin_blocked: false,
    quote_today: false,
    booking_date: '',
    cod_booking: false,
    hasAgent: false,
    free_booking: false,
    booking_name: '',
    booking_slug: '',
    tickets: [],
    address: {
        street: 'Rua teste',
        number: '0',
        complement: '',
        neighborhood: 'Teste',
        zipcode: '00000000',
        country: 'Brasil',
        state: 'BA',
        city: 'Lençóis',
    },
};

const atrativos = [];
const dialCodesArray = [];
const countriesArray = [];
const statesArray = [];
const citiesArray = [];
const callbackUrlMP = "";
const expressBookingResponse = ""
const wsStatusPaymentMP = "";

const place_public_data = {
    place: {
        name: '',
        xfields: { logotipo: '' }
    }
}

const terms_conditions = ""

export default {
    reservaForm,
    atrativos,
    place_public_data,
    terms_conditions,
    dialCodesArray,
    countriesArray,
    statesArray,
    citiesArray,
    callbackUrlMP,
    expressBookingResponse,
    wsStatusPaymentMP,
}
